import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  header: {
    defaultMessage: 'Pickup Contact',
    id: 'AVFaxm',
    description: 'modal header to create a new pickup contact',
  },
  contactDescription: {
    defaultMessage: 'The person a driver will contact with questions about the pickup location, or ask for when initiating a pickup.',
    id: 'K6OyrG',
    description: 'newShipFromContactModal.contactDescription',
  },
  cancel: {
    defaultMessage: 'Cancel',
    id: 'rku4R+',
    description: 'newShipFromContactModal.cancel',
  },
  createContact: {
    defaultMessage: 'Save Contact',
    id: '7kvG1R',
    description: 'newShipFromContactModal.createContact',
  },
  fullName: {
    defaultMessage: 'Full Name',
    id: 'Dkfp07',
    description: 'newShipFromContactModal.inputLabel.fullName',
  },
  email: {
    defaultMessage: 'Email',
    id: 'FbrC+h',
    description: 'newShipFromContactModal.inputLabel.email',
  },
  phoneNumber: {
    defaultMessage: 'Phone Number',
    id: 'uDjWnq',
    description: 'newShipFromContactModal.inputLabel.phoneNumber',
  },
  extension: {
    defaultMessage: 'Extension <span>(optional)</span>',
    id: '8x9iWs',
    description: 'newShipFromContactModal.inputLabel.extension',
  },
  defaultLocationNotes: {
    defaultMessage: 'Default Location Notes',
    id: 'sQV2A3',
    description: 'newShipFromContactModal.inputLabel.defaultLocationNotes',
  },
});
